import React from 'react';
import Button from '@mui/material/Button';
import { globalConfig } from '../configuration/config';
import { useTranslation } from 'react-i18next';

const OpenParentChatButton = ({ parentChatGuid, userCompanies }) => {
  const { t } = useTranslation();

  if (!parentChatGuid) {
    return null;
  }

  const handleButtonClick = async () => {
    try {
      const response = await fetch(
        `${globalConfig.config.common.api}Companies/GetCompanyByProjectGuid?projectGuid=${parentChatGuid}`,
        { credentials: 'include' }
      );

      if (!response.ok) {
        throw new Error(t('openParentChat.errorFetchingCompany'));
      }

      const companyData = await response.json();
      const companyFound = userCompanies.some((company) => company.id === companyData.id);

      if (companyFound) {
        localStorage.setItem('company', JSON.stringify({ id: companyData.id }));
        window.location.href = `${globalConfig.config.common.chat}?pr=${parentChatGuid}`;
      } else {
        alert(t('openParentChat.accessDenied', { company: companyData?.name ?? '' }));
      }
    } catch (error) {
      console.error(t('openParentChat.requestErrorConsole'), error);
      alert(t('openParentChat.checkAccessError', { chatGuid: parentChatGuid }));
    }
  };

  return (
    <Button className="bm-item menu-item" onClick={handleButtonClick}>
      {t('openParentChat.openOriginalChat')}
    </Button>
  );
};

export default OpenParentChatButton;
